import { Component } from 'react'

import { Icon } from '@joor/design-system'
import PropTypes from 'prop-types'

import { Modal, Radio } from 'components/Core'
import Dropdown from 'components/Core/Dropdown/Dropdown'

import messages from './ChangeSalesRepModal.messages'
import styles from './ChangeSalesRepModal.module.css'
import ChangeSalesRepIds from './changeSalesRepModal.ids'

export const UPDATE_ALL_ORDERS = 1
export const UPDATE_SELECTED_ORDERS = 2

class ChangeSalesRepModal extends Component {
  state = {
    salesRepId: null,
    updateMode: this.props.selectedOrderIds?.length
      ? UPDATE_SELECTED_ORDERS
      : UPDATE_ALL_ORDERS,
  }
  getSalesRepName = (name, code) => (code ? `${name} (${code})` : name)

  setSalesRep = (e, { value }) => {
    this.setState({
      ...this.state,
      salesRepId: value,
    })
  }
  setUpdateMode = (updateMode) => {
    this.setState({ ...this.state, updateMode })
  }

  getDropdownOptions = () =>
    this.props.salesReps.map((option) => ({
      value: option.id,
      text: this.getSalesRepName(option.name, option.code),
      className: 'notranslate',
    }))

  handlePrimaryAction = () => {
    const { salesRepId, updateMode } = this.state
    if (!salesRepId) {
      return
    }

    const {
      client,
      handleUpdateOrderSalesRep,
      handleResetOrder,
      renderActionsToasterMessage,
      renderErrorNotification,
      selectedOrderIds,
    } = this.props
    this.props.setPageLoaderActive(true)

    let success = false
    handleUpdateOrderSalesRep(updateMode, salesRepId)
      .then(({ data: { bulkUpdateOrderSalesRepByFilters } }) => {
        success = true
        const ordersWithErrors =
          selectedOrderIds.length -
          bulkUpdateOrderSalesRepByFilters.updatedOrdersCount
        renderActionsToasterMessage(
          bulkUpdateOrderSalesRepByFilters.updatedOrdersCount,
          updateMode === UPDATE_SELECTED_ORDERS ? ordersWithErrors : 0,
        )
        handleResetOrder(false)
        client.resetStore()
      })
      .finally(() => {
        if (!success) {
          if (updateMode === UPDATE_SELECTED_ORDERS) {
            renderActionsToasterMessage(0, selectedOrderIds.length)
          } else {
            renderErrorNotification(messages.errorWhileUpdatingAllOrders)
          }
        }
        this.props.setPageLoaderActive(false)
      })
  }

  renderUpdateModeSelection = () => {
    const { selectedOrderIds, totalCount } = this.props
    const { updateMode, salesRepId } = this.state

    return (
      <>
        <div className={styles.radioOptions}>
          {updateMode === UPDATE_ALL_ORDERS && (
            <div className={styles.radioContainer}>
              <Radio
                id={ChangeSalesRepIds.UpdateAllRadioButton}
                data-testid={ChangeSalesRepIds.UpdateAllRadioButton}
                className={styles.radio}
                checked={updateMode === UPDATE_ALL_ORDERS}
                value={UPDATE_ALL_ORDERS}
              />
              {messages.updateAll(totalCount)}
            </div>
          )}
          {updateMode === UPDATE_SELECTED_ORDERS && (
            <div className={styles.radioContainer}>
              <Radio
                id={ChangeSalesRepIds.UpdateSelectedRadioButton}
                data-testid={ChangeSalesRepIds.UpdateSelectedRadioButton}
                className={styles.radio}
                checked={updateMode === UPDATE_SELECTED_ORDERS}
                value={UPDATE_SELECTED_ORDERS}
              />
              {messages.updateSelected(selectedOrderIds.length)}
            </div>
          )}
        </div>
        {updateMode === UPDATE_ALL_ORDERS && !!salesRepId && (
          <div className={styles.warning}>
            <Icon iconName="warning" />
            <p>{messages.updateAllWarning(totalCount)}</p>
          </div>
        )}
      </>
    )
  }

  render() {
    return (
      <Modal
        className={styles.ChangeSalesRepModal}
        title={messages.changeSalesRep}
        primaryActionLabel={messages.update}
        primaryDisabled={!this.state.salesRepId}
        primaryActionOnClick={this.handlePrimaryAction}
        open
        onClose={this.props.onClose}
        id={ChangeSalesRepIds.Title}
        primaryId={
          this.state.updateMode === UPDATE_ALL_ORDERS
            ? ChangeSalesRepIds.UpdateAllFiltered
            : ChangeSalesRepIds.UpdateSelected
        }
      >
        <p>{messages.selectOption}</p>
        <div className={styles.dropdown}>
          <Dropdown
            placeholder={messages.selectOne}
            options={this.getDropdownOptions()}
            onChange={this.setSalesRep}
            search
            className={this.state.salesRepId ? 'notranslate' : ''}
          />
        </div>
        {this.renderUpdateModeSelection()}
      </Modal>
    )
  }
}

ChangeSalesRepModal.propTypes = {
  selectedOrderIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  salesReps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      code: PropTypes.string,
    }),
  ).isRequired,
  onClose: PropTypes.func.isRequired,
  setPageLoaderActive: PropTypes.func,
  handleResetOrder: PropTypes.func,
  renderActionsToasterMessage: PropTypes.func.isRequired,
  renderErrorNotification: PropTypes.func.isRequired,
  totalCount: PropTypes.number,
}

export default ChangeSalesRepModal
